var __TEMP__ = require('./_ListCache.js');var ListCache = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = stackClear;
